var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHuntIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.0002 1V5.00002C31.0002 6.0609 30.5788 7.07832 29.8286 7.82847C29.0785 8.57862 28.061 9.00005 27.0002 9.00005H5.00002C3.93915 9.00005 2.92173 8.57862 2.17158 7.82847C1.42143 7.07832 1 6.0609 1 5.00002V1",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0011 17.9999C25.0011 23 20.9711 31 16.001 31C11.031 31 7.00098 23 7.00098 17.9999C7.00098 15.613 7.94919 13.3238 9.63703 11.6359C11.3249 9.9481 13.6141 8.99988 16.001 8.99988C18.388 8.99988 20.6772 9.9481 22.365 11.6359C24.0529 13.3238 25.0011 15.613 25.0011 17.9999Z",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9995 27.0005C17.6564 27.0005 18.9995 25.6574 18.9995 24.0005C18.9995 22.3436 17.6564 21.0005 15.9995 21.0005C14.3427 21.0005 12.9995 22.3436 12.9995 24.0005C12.9995 25.6574 14.3427 27.0005 15.9995 27.0005Z",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00098 4.99976V8.99978",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9995 4.99976V8.99978",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4893 12.9996H30.9993C30.9993 14.5909 30.3672 16.1171 29.2419 17.2423C28.1167 18.3675 26.5906 18.9997 24.9993 18.9997",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.51005 12.9996H1C1 14.5909 1.63214 16.1171 2.75737 17.2423C3.8826 18.3675 5.40873 18.9997 7.00004 18.9997",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHuntIcon);
export default __webpack_public_path__ + "static/media/huntIcon.bead568b4f8655ee2b828f57d33febfa.svg";
export { ForwardRef as ReactComponent };